import React from 'react';
import moment from 'moment';
import {Input, Row, Col, InputNumber, Select, TreeSelect, DatePicker, Form, Cascader} from 'antd';
import styles from './youkee.less';

const FormItem = Form.Item;

//高级搜索的表单中的数值类型字段(大于、小于、等于)
export class NumCompare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            text: props.text,
            handle: props.handle,
            val: {
                gt: '',
                lt: '',
                eq: ''
            }
        };
        this.gtChange = this.gtChange.bind(this);
        this.ltChange = this.ltChange.bind(this);
        this.eqChange = this.eqChange.bind(this);
        this.reset = this.reset.bind(this);
    }

    gtChange(value) {
        var val = this.state.val;
        val.eq = '';
        val.gt = value || '';

        this.setState({val: val});
        this.state.handle(this.state.name, val);
    }

    ltChange(value) {
        var val = this.state.val;
        val.eq = '';
        val.lt = value || '';
        this.setState({val: val});
        this.state.handle(this.state.name, val);
    }

    eqChange(value) {
        var val = this.state.val;
        val.eq = value || '';
        val.lt = '';
        val.gt = '';
        this.setState({val: val});
        this.state.handle(this.state.name, val);
    }

    reset() {
        var val = this.state.val;
        val.eq = '';
        val.lt = '';
        val.gt = '';
        this.setState({val: val});
        this.state.handle(this.state.name, val);
    }

    render() {
        var text = this.state.text;
        return (
            <div>
                <label className={styles.uk_label}>{this.state.label}:</label>
                <Row>
                    <Col span={8}>
                        <FormItem
                            labelCol={{span: 5}}
                            wrapperCol={{span: 19}}
                            label={'>'}
                            style={{marginBottom: '5px'}}
                        >
                            <InputNumber min={1} value={this.state.val.gt} placeholder={text} onChange={this.gtChange}/>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem
                            labelCol={{span: 5}}
                            wrapperCol={{span: 19}}
                            label={'<'}
                            style={{marginBottom: '5px'}}
                        >
                            <InputNumber min={1} value={this.state.val.lt} placeholder={text} onChange={this.ltChange}/>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem
                            labelCol={{span: 5}}
                            wrapperCol={{span: 19}}
                            label={'='}
                            style={{marginBottom: '5px'}}
                        >
                            <InputNumber min={1} value={this.state.val.eq} placeholder={text} onChange={this.eqChange}/>
                        </FormItem>
                    </Col>
                </Row>
            </div>
        );
    }
}

//高级搜索的表单中的下拉多选字段(用于选项多于3个时)
export class SelectGroup extends React.Component {
    constructor(props) {
        super(props);
        this.oldVal = props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : null;
        this.state = {
            name: props.name,
            label: props.label,
            multiple: props.multiple || false,
            handle: props.handle,
            //val: [],
            val: props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : []
        };

        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue && newProps.defaultValue !== this.oldVal) {
            if (this.state.multiple) {
                //this.oldVal = [...newProps.defaultValue]
                this.setState({val: [...newProps.defaultValue]});
            } else {
                //this.oldVal = newProps.defaultValue
                this.setState({val: newProps.defaultValue});
            }
        }
    }

    changeHandle(value) {
        let dataType = this.props.dataType
        this.setState({val: value});

        if (dataType === 'number') {
            if ((value instanceof Array) && value.length > 0) {
                this.state.handle(this.state.name, value.map(x => {
                    return isNaN(parseInt(x, 10)) ? null : parseInt(x, 10)
                }));
            } else if ((typeof value === 'string') && value.length > 0) {
                //this.state.handle(this.state.name, parseInt(value, 10));
                this.state.handle(this.state.name, isNaN(parseInt(value, 10)) ? null : parseInt(value, 10));
            } else {
                this.state.handle(this.state.name, null);
            }
        } else {
            this.state.handle(this.state.name, value);
        }
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        var {options} = this.props;
        let idVal = 'area' + Math.random();

        if (!(options instanceof Array)) {
            return null;
        }

        return (
            <div style={{position: 'relative'}} id={idVal}>
                <label className={styles.uk_label}>{this.state.label}:</label>
                <Row className={styles.uk_mgb_24}>
                    <Col span={24}>
                        <Select
                            mode={this.state.multiple ? 'multiple' : ''}
                            name={this.state.name}
                            style={{width: '100%'}}
                            defaultValue={this.oldVal}
                            value={this.state.val}
                            placeholder={this.state.text}
                            onChange={this.changeHandle}
                            getPopupContainer={() => document.getElementById(idVal)}
                        >
                            {options.map(function (item, key) {
                                return <Select.Option key={key + ''} value={item.value + ''}>{item.text}</Select.Option>
                            })}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export class TreeSelectGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            multiple: props.multiple || false,
            handle: props.handle,
            val: props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : []
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    changeHandle(value) {
        let dataType = this.props.dataType;
        this.setState({val: value});

        if (dataType === 'number') {
            if ((value instanceof Array) && value.length > 0) {
                this.state.handle(this.state.name, value.map(x => {
                    return isNaN(parseInt(x, 10)) ? null : parseInt(x, 10)
                }));
            } else if ((typeof value === 'string') && value.length > 0) {
                //this.state.handle(this.state.name, parseInt(value, 10));
                this.state.handle(this.state.name, isNaN(parseInt(value, 10)) ? null : parseInt(value, 10));
            } else {
                this.state.handle(this.state.name, null);
            }
        } else {
            this.state.handle(this.state.name, value);
        }
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        const {multiple, name, val, label} = this.state;
        var {options, dropdownStyle, showSearch} = this.props;
        let idVal = 'area' + Math.random();

        if (!(options instanceof Array)) {
            return null;
        }

        return (
            <div style={{position: 'relative'}} id={idVal}>
                <label className={styles.uk_label}>{this.state.label}:</label>
                <Row className={styles.uk_mgb_24}>
                    <Col span={24}>
                        <TreeSelect
                            size="large"
                            value={val}
                            name={name}
                            multiple={multiple ? true : false}
                            treeCheckable={multiple ? true : false}
                            treeDefaultExpandAll
                            style={{width: '100%'}}
                            showSearch={showSearch}
                            dropdownStyle={{...dropdownStyle}}
                            showCheckedStrategy={TreeSelect.SHOW_ALL}
                            treeData={options}
                            placeholder={label}
                            onSelect={this.changeHandle}
                            getPopupContainer={() => document.getElementById(idVal)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

//高级搜索的表单中的文本字段
export class TextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            text: props.text,
            handle: props.handle,
            //val: ''
            val: props.defaultValue ? props.defaultValue : ''
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillMount() {
        this.setState({
            val: this.props.defaultValue ? this.props.defaultValue : ''
        });
    }

    changeHandle(e) {
        this.setState({val: e.target.value});
        // this.state.handle(this.state.name, {like: e.target.value});
        this.state.handle(this.state.name, e.target.value);
    }

    reset() {
        this.setState({val: ''});
        this.state.handle(this.state.name, '');
    }

    render() {
        return <div>
            <label className={styles.uk_label}>{this.state.label}:</label>
            <Row className={styles.uk_mgb_24}>
                <Col span={24}>
                    <Input name={this.state.name} value={this.state.val || this.props.defaultValue}
                           placeholder={this.state.text}
                           onChange={this.changeHandle}/>
                </Col>
            </Row>
        </div>
    }
}

//高级搜索的表单中的日期类型字段(之前、之后、当前)
export class DateCompare extends React.Component {
    constructor(props) {
        super(props);
        this.dateFormat = 'YYYY-MM-DD';
        if (props.defaultValue) {
            this.oldVal = {
                from: props.defaultValue.from || '',
                end: props.defaultValue.from || '',
            }
        }
        this.oldVal = props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : null;
        this.state = {
            name: props.name,
            label: props.label,
            options: props.options,
            handle: props.handle,
            /*optData: {
              from: props.defaultValue && props.defaultValue.from ? moment(props.defaultValue.from, dateFormat) : null,
              end: props.defaultValue && props.defaultValue.end ? moment(props.defaultValue.end, dateFormat) : null,
            },
            val: {
              from: props.defaultValue && props.defaultValue.from ? props.defaultValue.from : '',
              end: props.defaultValue && props.defaultValue.end ? props.defaultValue.end : '',
            },*/
            optData: {
                from: null,
                end: null,
            },
            val: {
                from: '',
                end: '',
            },
            endOpen: false,
        };
        this.fromChange = this.fromChange.bind(this);
        this.endChange = this.endChange.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue && (!this.state.optData.from)) {
            this.setState({
                ...this.state,
                optData: {
                    ...this.state.optData,
                    from: newProps.defaultValue && newProps.defaultValue.from ? moment(newProps.defaultValue.from, this.dateFormat) : null,
                    end: newProps.defaultValue && newProps.defaultValue.end ? moment(newProps.defaultValue.end, this.dateFormat) : null,
                },
                val: {
                    ...this.state.val,
                    from: newProps.defaultValue && newProps.defaultValue.from ? newProps.defaultValue.from : '',
                    end: newProps.defaultValue && newProps.defaultValue.end ? newProps.defaultValue.end : '',
                }
            }, () => {
                this.disabledStartDate(this.state.optData.from);
                this.disabledEndDate(this.state.optData.end);
            });
        }
    }

    fromChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.from = date;
        optData.end = null;

        var val = this.state.val;
        val.from = dateString || '';
        val.end = '';

        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    endChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.end = date;

        var val = this.state.val;
        val.end = dateString || '';
        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    reset() {
        var optData = this.state.optData;
        optData.end = null;
        optData.from = null;

        var val = this.state.val;
        val.end = '';
        val.from = '';
        this.setState({optData: optData, val: val});
        this.state.handle(this.state.name, val);
    }

    disabledStartDate = (startValue) => {
        const endValue = this.state.optData.end;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = this.state.optData.from;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }

    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({endOpen: true});
        }
    }

    handleEndOpenChange = (open) => {
        this.setState({endOpen: open});
    }

    render() {
        const {endOpen, optData, options} = this.state;
        return (
            <div>
                <label className={styles.uk_label}>{this.state.label}:</label>
                <Row>
                    <Col span={12}>
                        <FormItem wrapperCol={{span: 24}} style={{marginBottom: '5px', paddingRight: '5px'}}>
                            <DatePicker disabledDate={this.disabledStartDate}
                                        onChange={this.fromChange}
                                        value={optData.from}
                                        placeholder={options[0].text}
                                        onOpenChange={this.handleStartOpenChange}
                                        style={{width: '100%'}}/>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem wrapperCol={{span: 24}} style={{marginBottom: '5px', paddingLeft: '5px'}}>
                            <DatePicker disabledDate={this.disabledEndDate}
                                        onChange={this.endChange}
                                        value={optData.end}
                                        placeholder={options[1].text}
                                        open={endOpen}
                                        onOpenChange={this.handleEndOpenChange}
                                        style={{width: '100%'}}/>
                        </FormItem>
                    </Col>
                </Row>
            </div>
        );
    }
}

//高级搜索的表单中的级联选择
export class CascaderOption extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            handle: props.handle,
            val: props.defaultValue
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    changeHandle(value) {
        this.setState({val: value});
        this.state.handle(this.state.name, value);
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        var {options, showSearch, changeOnSelect} = this.props;
        let idVal = 'area' + Math.random();

        if (!(options instanceof Array)) {
            return null;
        }

        return (
            <div style={{position: 'relative'}} id={idVal}>
                <label className={styles.uk_label}>{this.state.label}:</label>
                <Row className={styles.uk_mgb_24}>
                    <Col span={24}>
                        <Cascader value={this.state.val.length == 0 ? this.props.defaultValue : this.state.val}
                                  changeOnSelect={changeOnSelect} options={options} showSearch={showSearch}
                                  onChange={this.changeHandle} placeholder={this.state.label}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/corAdvanceFormItem.js